import React from 'react';
import PropTypes from 'prop-types';
import { PageDescriptor } from './PageDescriptor';
import { SkillTable } from './SkillTable';
import '../styles/hcHomepageStyles.css';

export const Homepage = (props) => {
    return (
        <div className="homepageLayout">
            <PageDescriptor 
                pageDescription={props.pageDescription}
                clickText={props.clickText}
                helpURL={props.helpURL}
            />
            <SkillTable
                containerNames={props.containerNames}
                toolTipText={props.toolTipText}
                activitiesTxt={props.activitiesTxt}
                activityAmounts={props.activityAmounts}
                handleSkillClick={props.handleSkillClick}
            />
        </div>
    );
}; 

Homepage.propTypes = {
    pageDescription: PropTypes.string.isRequired,
    clickText: PropTypes.string.isRequired,
    helpURL: PropTypes.string.isRequired,
    containerNames: PropTypes.array.isRequired,
    toolTipText: PropTypes.array.isRequired, 
    activitiesTxt: PropTypes.string.isRequired,
    activityAmounts: PropTypes.array.isRequired,
    handleSkillClick: PropTypes.func.isRequired,
};

export default Homepage;




// WEBPACK FOOTER //
// ./src/components/HomePage.jsx